import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { DevToolsPage } from '../../components/devtools';

export const devToolsPageExtension = PageBlueprint.make({
  params: {
    path: '/dev-tools',
    loader: async () => <DevToolsPage />,
  },
});
